import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Divider } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function Infra() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="lg:block hidden">
      <p className=" py-10  text-4xl !text-center underline text-[#1345b7!important]">
        IT Infrastructure Services
      </p>
      <Box
        className="!ml-20 !w-max  shadow-sky-200 shadow-2xl !px-4 !pt-10 !border border-blue-800"
        sx={{
          margin: 5,
          flexGrow: 1,
          justifyItem: "center",
          bgcolor: "",
          display: "flex",
          height: 500,
        }}
      >
        <Tabs
          orientation="vertical"
          className="!px-5"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{}}
        >
          <Tab
            label={
              <Button
                variant="contained"
                className="!bg-[#1345b7!important] !px-8"
              >
                FireWall
              </Button>
            }
            {...a11yProps(0)}
          />
          <Divider />
          <Tab
            label={
              <Button
                variant="contained"
                className="!bg-[#1345b7!important] !px-8"
              >
                Data Encryption
              </Button>
            }
            {...a11yProps(1)}
          />
          <Divider />
          <Tab
            label={
              <Button
                variant="contained"
                className="!bg-[#1345b7!important] !px-8"
              >
                Data Analysis
              </Button>
            }
            {...a11yProps(2)}
          />
          <Divider />
          <Tab
            label={
              <Button
                variant="contained"
                className="!bg-[#1345b7!important] !px-8"
              >
                Cloud Deployement
              </Button>
            }
            {...a11yProps(3)}
          />
          <Divider />
          <Tab
            label={
              <Button
                variant="contained"
                className="!bg-[#1345b7!important] !px-8"
              >
                Technical support
              </Button>
            }
            {...a11yProps(4)}
          />
        </Tabs>

        <TabPanel value={value} index={0} className="px-3  !text-2xl  ">
          <p className=" text-2xl  text-[#1345b7!important] font-bold">
            Firewall
          </p>{" "}
          <br />
          <p className="text-[#1345b7!important] text-2xl ">
            For your business with on line presense, there is need of security
            as well <br /> to avoid cyber security. It alwayshelps in trust
            factor. Firewalls are <br /> very categorized as either network
            layer firewalls or server-based firewalls.
            <br />
            Aara clouds team deploy on-demand open-source cost-effective
            firewall for <br />
            inhouse customer IT infrastructures. <br />
            The team is available 24*7 for support in terms of maintenance.{" "}
            <br /> Book an appointment with a sales representative now.
          </p>
          <div className="flex gap-5 py-4 pt-10 font-bold pr-10 text-[#1345b7!important] ">
            <p> Cheap in costing</p> <p> Best in performance</p>{" "}
            <p> Banswidth control</p> <p> Easy to manage</p>{" "}
            <p>Traffic stats</p> <p> VPN Enabled</p>
          </div>
        </TabPanel>

        <TabPanel value={value} index={2} className="">
          <p className=" text-2xl  text-[#1345b7!important] font-bold">
            Data Encryption
          </p>{" "}
          <br />
          <p className="text-[#1345b7!important] text-2xl">
            Data encryption is always an initial approach to improve security in
            any data <br />
            communication.Basically there is should be one secret key to
            translate data into <br />
            another form.. Currently, encryption is one of the most popular and
            effective
            <br /> data security methods used by many organizations..
            <br /> Aara clouds deploy on-demand VPN, make ready customers
            environment access with <br />
            secret keys.. Book an appointment with a sales representative now.
          </p>
          <div className="flex gap-3 font-bold py-4  pt-10  text-[#1345b7!important] ">
            <p> Unique algorithm</p> <p> Google authenticator integration</p>{" "}
            <p>Latest patch for security</p> <p>Unlimited users</p>{" "}
            <p>OTP Based security</p> <p>Cheap in costing</p>
          </div>
        </TabPanel>

        <TabPanel value={value} index={4} className="!px-3 ">
          <p className=" text-2xl  text-[#1345b7!important] font-bold">
            Data Analysis
          </p>{" "}
          <br />
          <p className="text-[#1345b7!important] text-2xl">
            Data analysis is a process of inspecting, cleansing, transforming
            and modeling data <br />
            with the goal of discovering useful information, informing
            conclusion and supporting
            <br /> decision-making.Data analysis has multiple facets and
            approaches, encompassing diverse
            <br /> techniques under a variety of names,
            <br /> and is used in different business, <br />
            science, and social science domains. In today’s business world, data
            analysis <br />
            plays a role in making decisions more <br />
            scientific and helping businesses operate more effectively.
          </p>
          <div className="flex gap-3 py-4 font-bold pt-10  !pb-10 text-[#1345b7!important] ">
            <p> Best dashboard interface</p> <p>Script enabled data filter</p>{" "}
            <p>Visual Reviews</p> <p> Experienced support</p>{" "}
            <p> Formula based filtering</p> <p> Latest Generation</p>
          </div>
        </TabPanel>
        <TabPanel value={value} index={6} className="!px-3">
          <p className=" text-2xl  text-[#1345b7!important] font-bold">
            Private Cloud
          </p>{" "}
          <br />
          <p className="text-[#1345b7!important] text-2xl">
            In the current digital world, most of content available on internet
            are not secure. <br />
            that’s organizations always recommend having most of there in house
            development
            <br /> work to not be shared on the open-world on the internet.{" "}
            <br />
            Aara clouds always ready with a dedicated team of experts to make IT
            infra ready
            <br /> with private clouds with various open-source based platform
            i.e Redhat/ ubuntu OpenStack. <br />
            we have our own customized scripts to make environment readiness.
            <br /> fast stability test post readiness . Book an appointment with
            a sales representative now.
          </p>
          <div className="flex gap-10 font-bold py-4  pt-10  text-[#1345b7!important] ">
            <p>Redhat & Debian</p> <p>UI Based vm creation</p>{" "}
            <p>OS Firewall enabled</p> <p> Security rules</p>{" "}
            <p> Essy to manage</p> <p> Architecture Design</p>
          </div>
        </TabPanel>

        <TabPanel value={value} index={8} className="!px-3  ">
          <p className=" text-2xl  text-[#1345b7!important] font-bold">
            Technical Support
          </p>{" "}
          <br />
          <p className="text-[#1345b7!important] text-2xl">
            Dedicated Team with on-call support, 24*7 availability. <br />
            Expertise in quick resolutions, Ticket systems to maintain SLA based
            agreement.
            <br /> W are serving customers across the globe with the best
            feedback so far.
          </p>
          <div className="flex gap-5 font-bold py-4  pt-10  text-[#1345b7!important] ">
            <p> 24*7 support</p> <p> Experienced Team</p>{" "}
            <p>Monthly review for support</p>{" "}
            <p> Ticket tool from Aara clouds</p> <p> Fast Resolution</p>{" "}
            <p> L1/L2 support</p>
          </div>
        </TabPanel>
      </Box>
    </div>
  );
}
